exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file[data-v-00d1578c],.file2[data-v-00d1578c]{visibility:hidden;position:absolute}", ""]);

// exports
